<template>
     <div>
        <a-form layout='inline'>
           <a-form-item label="关键词">
              <a-input type="text" v-model:value="form.keyword" placeholder="请输入批次ID/批次名称" style="width:260px"></a-input>
           </a-form-item>
           <a-form-item label="操作时间">
               <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="onChange" />
           </a-form-item>
           <a-form-item>
               <a-button type="primary" @click="onSearch">搜索</a-button>
           </a-form-item>
        </a-form>
        <a-table class="m-t-20" :pagination='pagination' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='list' @change="changePage">
            <template v-slot:action="{ record }">
                <a href="javaScript:;" v-has:operationRecordDetail="()=>{getDetail(record)}">查看详情</a>
            </template>
        </a-table>
        <!-- 详情 -->
        <a-modal  :keyboard="false" title="详情" centered v-model:visible="modalVisible" :width='600' :footer="null" destroyOnClose>
            <div>
                <p>批次名称：{{historyData.batch_name}}</p>
                <p class="m-t-20">关联商品：{{historyData.product_name}}</p>
                <p class="m-t-20">生产日期：{{historyData.production_date}}</p>
                <p class="m-t-20">有效期：<span v-if="historyData.validaity_mode==1">{{historyData.validaity_day}}天</span><span v-else>{{historyData.validity_date}}</span></p>
                <p class="m-t-20">备注：{{historyData.remark || '无'}}</p>
                <p class="s_flex m-t-20">
                    <span>检验报告：</span>
                    <span style="flex:1">
                        <img :src="item?info.picdomain +'/'+item:'@/assets/images/normal.png'" style="width:60px;height:60px;margin-right:10px;margin-bottom:10px;" class="s_bor5" v-for="(item,index) in historyData.inspection_report" :key="index"/>
                    </span>
                </p>
            </div>
        </a-modal>
    </div>
</template>

<script>
import { productBatch,productBatchHistory } from "@/api/product";
import { reactive, toRefs,ref, onMounted } from 'vue'
import { iscode } from '../../../../../utils/app';
import { message } from 'ant-design-vue';
import store from "@/store";
const columns = [
    {
      title: "批次ID",
      dataIndex: "old_id",
      key: "old_id",
    },
    {
      title: "批次名称",
      dataIndex: "batch_name",
      key: "batch_name",
    },
    {
      title: "操作类型",
      dataIndex: "operation_type_text",
      key: "operation_type_text",
    },
      {
      title: "操作人",
      dataIndex: "update_role_name",
      key: "update_role_name",
    },
    {
      title: "操作时间",
      dataIndex: "updated_at",
      key: "updated_at",
    },
    {
      title: "最后保存内容",
      dataIndex: "action",
      key: "action",
      slots: { customRender: "action" },
      width:140
    }
]
export default{
    setup(){
      const form = ref({
           keyword:'',
           page:1,
           limit:10,
           start_time:'',
           end_time:'',
           key_type:'batch_name'
      })
       const state = reactive({
             time:[],
             list:[],
             listLoading:false,
             pagination:{
               total:0,
               current:1,
               pageSize:10,
               showTotal:(total)=> `共 ${total} 条`,
               showSizeChanger:true,
               pageSizeOptions:['5','10', '20', '30', '40', '50'], 
               showQuickJumper:true
             },
             modalVisible:false,
             historyData:{},
             info: store.state.user.info
       })
       const methods= {
           onChange(e){
             console.log(e)
             state.time = e;
             form.value.start_time = e[0];
             form.value.end_time = e[1];
           },
          async getData(){
              const hide = message.loading('加载中...')
              state.listLoading = true;
              state.list = [];
               let res = await productBatch({...form.value}).then(res=>res.data);
               state.listLoading = false;
               setTimeout(hide)
               if(iscode(res)){
                state.list = res.data || [];
                state.pagination.current = res.meta.current_page;
                state.pagination.total = res.meta.total;
               }else{
                   message.error(res.msg)
               }
           },
           //详情
           async getDetail(record){
               state.modalVisible=true;
               const hide = message.loading('加载中...');
               let res = await productBatchHistory({batch_id:record.id}).then(res=>res.data);
               setTimeout(hide)
               if(iscode(res)){
                // console.log(res)
                state.historyData = res.data || {};
               }else{
                   message.error(res.msg)
               }
           },
           onSearch(){
               form.value.page = 1;
               methods.getData()
           },
           changePage(e){
              state.pagination.current = e.current;
              state.pagination.pageSize = e.pageSize;
              form.value.page = e.current;
              form.value.limit = e.pageSize || 10;
              methods.getData()
           }
       }
       onMounted(()=>{
           methods.getData()
       })
       return {
           ...toRefs(state),
           ...methods,
           form,
           columns
       }
    }
}
</script>
